import * as stylex from "@stylexjs/stylex";
import { fonts } from "@/fonts.stylex";

const sharedStyles = stylex.create({
  bodyText: {
    fontWeight: 425,
  },
  sectionHeading: {
    fontWeight: 500,
  },
  monoCaption: {
    fontFamily: fonts.mono,
    fontSize: "10.5px",
    letterSpacing: "0.6px",
    lineHeight: 1.5,
    textTransform: "uppercase",
  },
  pageHeading: {
    fontSize: "20px",
    fontWeight: 500,
  },
  srOnly: {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: 0,
  },
  stackTight: {
    display: "flex",
    flexDirection: "column",
    rowGap: "0.75rem",
  },
  stack: {
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
  },
  stackLoose: {
    display: "flex",
    flexDirection: "column",
    rowGap: "2rem",
  },
});

export { sharedStyles };
